import api from "../dataAccessLayer/firebase";

const initialState = {
    advsList: [],
    isLoading:false
};

const advReducer = (state = initialState, action) => {
    switch(action.type) {
        case "FETCH_ADV":
            return {
                ...state,
                advsList: action.advs,
                isLoading: true
            };
        case "ADV_UPDATE":
            return {
                ...state
            };
        default:
            return state
    };
};

export default advReducer;

//const advCreated = adv => ({type: "FETCH_ADV_CREATED", payload: adv})
//const advsRequested = () => ({type: "FETCH_ADV_REQUEST"})
const advsLoaded = advs => ({type: "FETCH_ADV", advs})
const advUpdate = () => ({type: "ADV_UPDATE"})



// Создание объявления
const addAdv = (imgUrl, address, price, priceHistory, phone, rooms, square, floor, description, date,userId) => (dispatch) => {
    api.addAdv(imgUrl, address, price, priceHistory, phone, rooms, square, floor, description, date, userId);
    dispatch(advUpdate());
};

// Удаление объявления
const deleteAdv = id => dispatch => {
    api.deleteAdv(id);
    dispatch(advUpdate());
};

// Изменение объявления
const updateAdv =  (id, imgUrl, address, price, priceHistory, phone,
                    rooms, square, floor, description,date,userId) => dispatch => {
    api.updateAdv(id, imgUrl, address, price, priceHistory, phone, rooms, square, floor, description, date,userId);
    dispatch(advUpdate());
};

// Загрузка объявлений
const fetchAdv = () => dispatch => {
    api.getAdv(response => {
        console.log(response);
        dispatch(advsLoaded(response))
    })
}

export {fetchAdv, addAdv, deleteAdv, updateAdv};
